import { useCallback, useState } from 'react';
import type { LoginGithubResponse } from 'api/github/handlers/loginGithubHandler';
import Api from 'client/lib/Api';

const loadOAuthURL = ({ invite, path }: { invite?: string | null; path?: string | null }) =>
  new Promise<string>((resolve, reject) =>
    Api.post<{}, LoginGithubResponse>('/github/login', { invite, path })
      .then(({ status, url }) => {
        if (status !== 'ok') return reject(status);
        return resolve(url);
      })
      .catch((error) => {
        console.error(error);
        return reject('unexpected error');
      })
  );

export const useGitHubLogin = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const handleAuthenticate = useCallback(async ({ token = null, path = null }: { token?: string | null; path?: string | null } = {}) => {
    setIsLoading(true);

    try {
      const url = await loadOAuthURL({ invite: token, path });
      window.location.href = url;
      umami.track('login-success', {});
    } catch (error: any) {
      console.error(error);
      setIsLoading(false);
      setIsError(true);
      umami.track('login-error', { error: error.toString()});
    }
  }, []);

  return { login: handleAuthenticate, isLoading, isError };
};
